import React from 'react'
export default function GlobalLoading() {
    return (
        <div className="loading-container">
            <div className="loader"></div>
        </div>
    )
}